import React, { createContext, useRef, useState, useEffect } from "react";

export const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [headerOffset, setHeaderOffset] = useState(0);
  const headerRef = useRef(null);
  useEffect(() => {
    // Function to update dimensions
    const updateHeaderOffset = () => {
      if (headerRef.current) {
        const { offsetHeight } = headerRef.current;
        setHeaderOffset(offsetHeight);
      }
    };

    // Update dimensions initially
    updateHeaderOffset();
    // Remove any which existed already
    window.removeEventListener("resize", updateHeaderOffset);
    // Add event listener to update dimensipons on window resize
    window.addEventListener("resize", updateHeaderOffset);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateHeaderOffset);
    };
  }, [headerRef?.current]);

  return (
    <HeaderContext.Provider value={{ headerRef, headerOffset }}>
      {children}
    </HeaderContext.Provider>
  );
};
